/**
 * 接口域名的管理
 */
const base = {
  // system: '/api',//dev调试地址
  system: '/web/api/front',//服务器地址s
};

export default base;
